import {ClientStateContext} from "../../quoteWizard/clientstatecontext.model";
import {Phone} from "../../models/phone.model";
import { UserProfile } from "../../models/models";

export class ClientStateContextSearchViewModel {

    clientStateContextId:string;
    clientStateContexts: Array<ClientStateContext>;
    primaryContacts: Array<UserProfile>;
    primaryContactPhones: Array<Phone>;
    primaryContactIds: Array<string>;
    searchResults: Array<ClientStateContextSearchResultModel>;
}

export class ClientStateContextSearchResultModel {

    clientStateContextId:string;
    primaryContactId:string;
    primaryContactFirstName: string;
    primaryContactLastName: string;
    primaryContactEmail: string;
    primaryContactPhone:string;
    createdAt:Date;
}